import { css, Theme } from '@mui/material'

export const sidebarContainer = css`
  display: none;
  @media (min-width: 1024px) {
    display: block;
    position: relative;
    flex: none;
    width: 280px;
  }
`

export const sidebarBackground = ({ theme }: { theme: Theme }) => css`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 50vw;
  background-color: ${theme.palette.white?.[100]};
  z-index: -1;
  @media (prefers-color-scheme: dark) {
    display: none;
  }
`

export const stickyNavigationWrapper = css`
  position: sticky;
  top: 4.75rem;
  height: calc(100vh - 4.75rem);
  width: 16rem;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 4rem;
  padding-bottom: 4rem;
  padding-right: 2rem;
  padding-left: 0.125rem;
  margin-left: -0.125rem;
scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    border: 3px solid transparent;
    background-clip: content-box;

    &:hover {
      background: rgba(0, 0, 0, 0.3);
      background-clip: content-box;
    }

  @media (min-width: 1280px) {
    width: 18rem;
    padding-right: 4rem;
  }
`

export const navRoot = css`
  font-size: 1rem;
  line-height: 1.5rem;
  @media (min-width: 1024px) {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`

export const spaceY9 = css`
  list-style: none;
  margin: 0;
  padding: 0;
  & > * + * {
    margin-top: 2.25rem;
  }
`

export const sectionTitle = css`
  display: flex;
  cursor: pointer;
  align-items: center;
  padding-right: 16px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: #0f172a;

  @media (prefers-color-scheme: dark) {
    color: #ffffff;
  }
`

export const sectionList = css`
  list-style: none;
  font-size: 14px;
  margin: 0;
  padding: 0;
  margin-top: 0.5rem;
  padding-left: 0;

  & > * + * {
    margin-top: 0.5rem;
  }

  @media (min-width: 1024px) {
    margin-top: 1rem;
  }

  @media (prefers-color-scheme: dark) {
    border-left-color: #1e293b;
  }
`

export const listItemRelative = css`
  position: relative;
`

export const linkStyles = (active: boolean, theme: Theme) => css`
  display: block;
  width: 100%;
  position: relative;
  padding: 8px 16px;
  line-height: 155%;
  text-decoration: none;
  transition: color 0.1s ease-in-out;

  ${active
    ? `
      color: ${theme.palette.black.main};
      background-color: #D2E9FA;
      font-weight: 600;
      border-radius: ${theme.spacing(2)};
    `
    : `
      color: ${theme.palette.black.main};
      &:hover {
        color: ${theme.palette.black.dark};
        background-color: #D2E9FA;
        border-radius: ${theme.spacing(2)};
      }
      &:hover::before {
        display: block; 
      }
    `}
`
